import { compose, withStateHandlers } from 'recompose';

export const withVouchersData = compose(
  withStateHandlers(
    {
      isLoaded: false,
      vouchersData: {},
      currentPageNumber: 1,
      currentStatus: 1,
    },
    {
      updateVouchersData: () => (
        isLoaded,
        vouchersData,
        currentPageNumber = 1,
        currentStatus = 1,
      ) => {
        if (!isLoaded) {
          window.scrollTo(0, 0);
        }

        return {
          isLoaded,
          vouchersData,
          currentPageNumber,
          currentStatus,
        };
      },
    },
  ),
);



// WEBPACK FOOTER //
// ./src/Account/Voucher/withVouchersData.js